import React, { useState, useEffect } from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import Image from "../../assets/Images/InvoiceImg1.svg";
import InvoiceForm from "../../components/invoices/InvoiceForm";
import InvoiceData from "../../components/invoices/InvoiceData";
import { useDispatch, useSelector } from "react-redux";
import {
  disconnectStripe,
  getCustomInvoices,
  getInvoiceList,
  sendStripeCode,
} from "../../stores/clients";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import { useLocation, useNavigate } from "react-router-dom";
import NoInvoicePage from "../../components/invoices/NoInvoicePage";
import { setToast } from "../../stores/toast/toastslice";
import CircularProgress from "@mui/material/CircularProgress";
import { BlueRightArrow } from "../../assets/Icon/headerCicon";

const Invoices = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { data, clientListStatus, total_records, error } = useSelector(
    (state: any) => state.clients,
  );

  const [page, setPage] = useState("setup");
  const [stripeCodeLoader, setStripeCodeLoader] = useState(false);
  const { state: pageState } = useLocation();

  useEffect(() => {
    if (
      data?.account?.account_id &&
      page === "setup" &&
      data?.invoices?.length
    ) {
      setPage("setup");
    }
  }, [data, page]);

  useEffect(() => {
    // Show loader for 6 seconds if code exists in URL
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) {
      setStripeCodeLoader(true);
      const timeout = setTimeout(() => {
        setStripeCodeLoader(false);
      }, 6000);
      return () => clearTimeout(timeout);
    }
  }, []);

  useEffect(() => {
    // Extract data from the URL after STRIPE success
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const fetch = async () => {
      if (code) {
        await dispatch<any>(sendStripeCode({ code, state })).then(
          async (res: any) => {
            console.log("invoicesssss");
            if (res?.payload?.code === 400 || res?.payload?.code === 422) {
              dispatch<any>(
                setToast({
                  message: res?.payload?.message || "Something went wrong!",
                  type: "error",
                  title: "Error",
                  onClose: () => {},
                }),
              );
            }
            const response = await dispatch<any>(
              getInvoiceList({ offset: 0, search: "", filter_by: -1 }),
            ).unwrap();
            const customInvoiceResponse = await dispatch<any>(
              getCustomInvoices({ offset: 0, limit: 10, search: "" }),
            ).unwrap();
            if (
              customInvoiceResponse?.data?.length &&
              response?.data?.account?.account_id
            ) {
              navigate("/tools/invoices/setup");
            }
            // if (response?.data &&
            //   Object.keys(response?.data)?.length &&
            //   !response?.data?.is_verified
            // ) {
            //   setPage("setup");
            //   return;
            // }
            if (
              response?.data?.account?.account_id &&
              response?.data?.invoices?.length
            ) {
              setPage("table");
            } else if (
              res?.payload?.data?.account_id &&
              !res?.payload?.data?.has_invoices
            ) {
              setPage("no-invoice");
              navigate("/tools/invoices/");
            } else {
              setPage("setup");
            }
          },
        );
      } else {
        try {
          const response = await dispatch<any>(
            getInvoiceList({ offset: 0, search: "", filter_by: -1 }),
          ).unwrap();
          if (response?.data?.detail?.includes("deactivated")) {
            navigate("/tools/invoices");
            return;
          }
          const customInvoiceResponse = await dispatch<any>(
            getCustomInvoices({ offset: 0, limit: 10, search: "" }),
          ).unwrap();
          if (!response?.data?.has_invoice_plan) {
            navigate("/tools/invoices");
            return;
          }
          if (pageState?.setUpStripe) {
            setPage("setup");
            return;
          }
          if (customInvoiceResponse?.data?.length) {
            navigate("/tools/invoices/setup");
            setPage("table");
            return;
          }
          // if (response?.data &&
          //   Object.keys(response?.data)?.length &&
          //   !response?.data?.is_verified
          // ) {
          //   setPage("setup");
          //   return;
          // }
          if (
            response?.data?.account?.account_id &&
            response?.data?.invoices?.length
          ) {
            setPage("table");
          } else if (
            response?.data?.account?.account_id &&
            !response?.data?.has_invoices
          ) {
            setPage("no-invoice");
            navigate("/tools/invoices/no-invoice");
          } else {
            setPage("setup");
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    fetch();
  }, [dispatch, navigate]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  if (loading || stripeCodeLoader) {
    return <ListLoadingNew />;
  }

  return (
    <Box
      sx={{
        mx: isMobile ? "5px" : "18px",
      }}
    >
      {page === "setup" && <SetUpStripe setPage={() => setPage("form")} />}
      {page === "form" && (
        <InvoiceForm
          setPage={() =>
            data?.account?.account_id ? setPage("table") : setPage("setup")
          }
        />
      )}
      {page === "table" && <InvoiceData setPage={() => setPage("setup")} />}
    </Box>
  );
};

export const SetUpStripe = ({ setPage }: { setPage: () => void }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const token = localStorage.getItem("user_token");
  const [btnLoading, setBtnLoading] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setBtnLoading(true);

    const stripeUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.REACT_APP_STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${process.env.REACT_APP_STRIPE_REDIRECT_URL}&state=${token}`;

    window.open(stripeUrl, "_blank", "noopener,noreferrer");

    setTimeout(() => {
      setBtnLoading(false);
    }, 4000);
  };
  const isLargeScreen = useMediaQuery("(max-width:1440px)");
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: isMobile ? 0 : 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "100vh",
          width: "100%",
          padding: isMobile ? 0 : 2,
          bgcolor: "white",
          marginTop: 1,
          paddingTop: isMobile ? 2 : 7,
          paddingBottom: 5,
          borderRadius: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "100%",
          }}
        >
          <img
            src={Image}
            alt="Invoices"
            style={{
              maxWidth: isLargeScreen ? "200px" : "256px",
              height: isLargeScreen ? "210px" : "268px",
            }}
          />
          <div
            style={{
              marginTop: isMobile ? "20px" : "28px",
              display: "grid",
              padding: isMobile ? "0 12px" : "0",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "20px" : isTablet ? "24px" : "28px",
                fontWeight: 700,
                textAlign: "center",
                margin: 0,
              }}
            >
              {/* Setup your Stripe account */}
              Connect your Stripe
            </p>
            <p
              style={{
                fontSize: isMobile ? "14px" : isTablet ? "15px" : "16px",
                color: "#6C6F71",
                width: isMobile ? "100%" : isTablet ? "400px" : "528px",
                textAlign: "center",
                marginTop: isMobile ? 8 : 10,
                margin: isMobile ? "8px 0 0 0" : "10px 0 0 0",
              }}
            >
              {/* Connect your Stripe account to start accepting payments, managing
              transactions, and receiving payouts securely. */}
              Your Invoicing Tool Will be Opened After you connecting your
              Stripe.
            </p>
            <button
              style={{
                margin: "auto",
                paddingTop: isMobile ? "12px" : "16px",
                paddingBottom: isMobile ? "12px" : "16px",
                paddingLeft: isMobile ? "24px" : "30px",
                paddingRight: isMobile ? "24px" : "30px",
                borderRadius: "8px",
                background: btnLoading
                  ? "#BDBDBD"
                  : "linear-gradient(to right, #2977CC, #1D538F)",
                color: "white",
                border: "none",
                fontSize: isMobile ? "14px" : "16px",
                fontWeight: 600,
                marginTop: isMobile ? "16px" : "22px",
                cursor: "pointer",
                minWidth: isMobile ? "140px" : "auto",
                height: "52px",
                opacity: btnLoading ? 0.7 : 1,
              }}
              onClick={btnLoading ? undefined : handleClick}
              disabled={btnLoading}
            >
              {btnLoading ? (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                  }}
                >
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                </span>
              ) : (
                "Setup Account"
              )}
            </button>
          </div>
          <div
            style={{
              display: "grid",
              justifyContent: "center",
              gap: 20,
              borderRadius: "12px",
              padding: "30px",
              width: "526px",
              marginTop: -5,
            }}
          >
            <p
              style={{
                fontWeight: 500,
                fontSize: "16px",
              }}
            >
              Not using Stripe? Easily create a custom invoice
            </p>
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                marginTop: 5,
                background: "#EAF1FA",
                border: "none",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: 600,
                color: "#2077cc",
                margin: "auto",
                width: "305px",
                height: "52px",
                cursor: "pointer",
              }}
              onClick={() => navigate("/tools/invoices/custom-invoice-form")}
            >
              Generate Custom Invoice
              <BlueRightArrow />
            </button>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Invoices;
